// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C5fm","badges":"styles_badges__1ZVi7"};